import React from "react";
import { Link } from "react-router-dom";
import DashboardHeader from "../../layouts/dashboard_header";
import SideMenu from "../../layouts/dashboard_menu";
import DashboardFooter from "../../layouts/dashboard_footer";
import Canvas from "../../layouts/dahboard_canvas";

export type CollaborationShellTab =
    | "overview"
    | "find-requests"
    | "partnership-requests"
    | "received-requests"
    | "accounting"
    | "reports";

interface CollaborationShellProps {
    title: string;
    description: string;
    activeTab: CollaborationShellTab;
    action?: React.ReactNode;
    children: React.ReactNode;
}

const tabs: Array<{ key: CollaborationShellTab; label: string; icon: string; to: string }> = [
    { key: "overview", label: "Workspace", icon: "bx bx-home-alt", to: "/institution/collaborations" },
    { key: "find-requests", label: "Opportunity Feed", icon: "bx bx-search-alt", to: "/institution/collaborations/find-requests" },
    { key: "partnership-requests", label: "Partner Outreach", icon: "bx bx-building-house", to: "/institution/collaborations/partnership-requests" },
    { key: "received-requests", label: "Agreements", icon: "bx bx-inbox", to: "/institution/collaborations/received-requests" },
    { key: "accounting", label: "Finance", icon: "bx bx-wallet-alt", to: "/institution/collaborations/accounting" },
    { key: "reports", label: "Reports", icon: "bx bx-file", to: "/institution/collaborations/reports" },
];

const CollaborationShell: React.FC<CollaborationShellProps> = ({ title, description, activeTab, action, children }) => {
    return (
        <>
            <DashboardHeader />
            <SideMenu />
            <div className="main-content">
                <div className="page-content">
                    <div className="sc-wrap">
                        <div className="sc-header">
                            <div>
                                <h1>{title}</h1>
                                <p>{description}</p>
                            </div>
                            {action}
                        </div>
                        <div className="sc-tabs">
                            {tabs.map((tab) => (
                                <Link
                                    key={tab.key}
                                    to={tab.to}
                                    className={`sc-tab ${activeTab === tab.key ? "active" : ""}`}
                                    style={{ textDecoration: "none" }}
                                >
                                    <i className={tab.icon}></i>
                                    {tab.label}
                                </Link>
                            ))}
                        </div>
                        {children}
                    </div>
                </div>
                <DashboardFooter />
            </div>
            <Canvas />
        </>
    );
};

export default CollaborationShell;
